import React from 'react';

const CloseIcon = ({
	width = 20,
	height = 20,
	...props
}: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			{...props}
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M5 15 15 5M5 5l10 10"
			></path>
		</svg>
	);
};

export default CloseIcon;
